export default function assert(cond, mess) {
	if (!cond) {
		throw new Error(mess);
	}
}
